module.exports = __webpack_public_path__ + "assets/email-account.c262ca3f.svg";